import { ElementType } from "react";
import {
  Link as ChakraLink,
  Icon,
  Text,
  LinkProps as ChakraLinkProps,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

interface NavLinkProps extends ChakraLinkProps {
  icon: ElementType;
  children: string;
  href?: string;
}

export function NavLink({ icon, children, href, ...rest }: NavLinkProps) {
  return (
    <Link
      id="another"
      style={{
        textDecoration: "none",
      }}
      //@ts-ignore
      to={href}
    >
      <ChakraLink
        display="flex"
        alignItems="center"
        {...rest}
        color="white"
        padding={2}
        w="200px"
        _hover={{
          color: "white",
          borderRadius: "4",
          padding: 2,
        }}
      >
        <Icon as={icon} fontSize="29" color="green_primary" />
        <Text ml="4" fontWeight="medium" fontSize="16">
          {children}
        </Text>
      </ChakraLink>
    </Link>
  );
}
